import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { FormContentChatComponent } from '../formcontentchat/formcontentchat.component';
import { AlertasComponent } from '../alertas/alertas.component';
import { GlobalService } from '../global.service';
import {EventBusService} from "ngx-eventbus";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.sass']
})
export class MenuComponent implements OnInit {
  @Input() tabActive: string;
  public session: string;
  public userName: string;
  public showMenuStatus: boolean = false;
  public menuMobile: boolean = false;
  public moduleData;
  public idData = [];
  public tabm = [];
  constructor(public global: GlobalService, public dialog: MatDialog, private router: Router, public appComponent: AppComponent, private eventBus: EventBusService) { }

  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.session = sessionStorage.getItem("session");
      //this.userName=sessionStorage.getItem("name");
      this.userName = atob(sessionStorage.getItem("companyName"));
      //si se pasa de caracteres evitando que se haya espacio
      if (this.userName.length > 18) {
        this.userName = this.userName.substring(0, 17) + "...";
      }
      if (this.session == 'true') {
        this.moduleData = JSON.parse(atob(sessionStorage.getItem("moduleData")));
        for (let index = 0; index < this.moduleData.length; index++) {
          this.tabm.push(false);
        }

      }
    }
  }
  tabmevery(i) {
    let state=this.tabm[i];
    for (let index = 0; index < this.tabm.length; index++) {
      this.tabm[index] = false;
    }
    this.tabm[i]=!state;
  }
  showMenu() {
    this.global.validateSession();
    if (this.showMenuStatus == false) {
      this.showMenuStatus = true;
    }
    else {
      this.showMenuStatus = false;
    }
  }
  closeMenu() {
    this.global.validateSession();
    this.showMenuStatus = false;
  }
  showMenuMobile() {
    this.global.validateSession();
    if (this.menuMobile == false) {
      this.menuMobile = true;
    }
    else {
      this.menuMobile = false;
    }
  }
  chat() {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    const dialogConfig2 = new MatDialogConfig();
    dialogConfig2.disableClose = true;
    dialogConfig2.autoFocus = true;
    const dialogRef = this.dialog.open(FormContentChatComponent, dialogConfig2);
  }
  logout() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: '¿Estás seguro que deseas cerrar la sesión?', btmConfirm: true };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {
        this.router.navigate(['login']);
      }
    });
  }

  emitEvent(path: string) {
    // console.log(path);
    if (path.includes('profile')) {
      this.eventBus.triggerEvent('myEvent', { message: path.charAt(path.length - 1) });
    }
  }
}
